/* 
* This file is auto-generated by Graphweaver. 
* Please do not edit it directly.
*/
import * as Types from '../../../../backend/src/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetScanHistoryQueryVariables = Types.Exact<{
  userId: Types.Scalars['ID']['input'];
}>;


export type GetScanHistoryQuery = { __typename?: 'Query', scanEvents?: Array<{ __typename?: 'ScanEvent', id: string, material?: Types.MaterialType | null, entriesGained: number, createdAt?: any | null, trackableAsset: { __typename?: 'TrackableAsset', scannableCode?: string | null } } | null> | null };


export const GetScanHistoryDocument = gql`
    query GetScanHistory($userId: ID!) {
  scanEvents(filter: {createdByUser: {id: $userId}}) {
    id
    material
    entriesGained
    createdAt
    trackableAsset {
      scannableCode
    }
  }
}
    `;

/**
 * __useGetScanHistoryQuery__
 *
 * To run a query within a React component, call `useGetScanHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScanHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScanHistoryQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetScanHistoryQuery(baseOptions: Apollo.QueryHookOptions<GetScanHistoryQuery, GetScanHistoryQueryVariables> & ({ variables: GetScanHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScanHistoryQuery, GetScanHistoryQueryVariables>(GetScanHistoryDocument, options);
      }
export function useGetScanHistoryLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScanHistoryQuery, GetScanHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScanHistoryQuery, GetScanHistoryQueryVariables>(GetScanHistoryDocument, options);
        }
export function useGetScanHistorySuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetScanHistoryQuery, GetScanHistoryQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetScanHistoryQuery, GetScanHistoryQueryVariables>(GetScanHistoryDocument, options);
        }
export type GetScanHistoryQueryHookResult = ReturnType<typeof useGetScanHistoryQuery>;
export type GetScanHistoryLazyQueryHookResult = ReturnType<typeof useGetScanHistoryLazyQuery>;
export type GetScanHistorySuspenseQueryHookResult = ReturnType<typeof useGetScanHistorySuspenseQuery>;
export type GetScanHistoryQueryResult = Apollo.QueryResult<GetScanHistoryQuery, GetScanHistoryQueryVariables>;